import { useContext } from 'react';
import { Avatar, Button, Divider, Stack, Typography } from '@mui/material';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { NextPrevButton } from 'Components';
import { InvoiceCard } from './InvoiceCard';
import { STEP } from '..';
import { UploadMoreInvoiceBtn } from 'Modules/Reimbursements/UploadMoreInvoiceBtn';
import { LightBlueX } from 'Images';
import { useNavigate } from 'react-router-dom';
import { CannabisContext } from 'Context/CannabisContext';

export const InvoiceList = () => {
  const {
    formData: { invoices },
    deleteInvoice,
    editInvoice,
    setShowUploadFileArea,
    currentStep,
    handleNextStep,
  } = useContext(CannabisContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements);
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();

  const getInvoicesSum = () => {
    return invoices
      .reduce((total, invoice) => total + (invoice.invoiceTotal || 0), 0)
      .toLocaleString();
  };

  return (
    <Stack sx={{ gap: '32px', maxWidth: '800px', m: '32px auto 0' }}>
      <Typography variant='body2' textAlign={isDesktop ? undefined : 'center'}>
        {dictionary.allInvoices}
      </Typography>
      {invoices.map((invoice, index) => (
        <InvoiceCard
          key={index}
          index={index}
          invoice={invoice}
          deleteInvoice={() => deleteInvoice(index)}
          editInvoice={() => editInvoice(index)}
        />
      ))}

      <UploadMoreInvoiceBtn
        onClick={() => setShowUploadFileArea(true)}
        formName={dictionary.typeCannabis}
      />

      <Divider
        aria-hidden='true'
        sx={{
          m: isDesktop ? '64px 0 0' : '0',
          width: '100%',
          borderColor: 'primary.shade_100',
        }}
      />
      <Typography variant='body3'>
        {dictionary.totalAmount} <strong>{getInvoicesSum()}</strong>{' '}
        {dictionary.nis}
      </Typography>
      <NextPrevButton
        callback={() => {
          if (currentStep === STEP.INVOICE_UPLOAD) {
            handleNextStep();
          } else if (currentStep === STEP.ADDITIONAL_DETAILS) {
            handleNextStep();
          }
        }}
        text={dictionary.save}
        style={
          isDesktop
            ? { button: { m: '0 auto' } }
            : {
                button: { height: '36px', width: '100%' },
                text: { fontSize: '16px', fontWeight: '600' },
              }
        }
        isBlue
        isNext
      />

      <Button
        startIcon={
          <Avatar
            src={LightBlueX}
            sx={{ width: '20px', height: '20px' }}
            alt=''
          />
        }
        variant='outlined'
        sx={{
          color: 'primary.main',
          width: 'fit-content',
          m: '0 auto',
          fontSize: '16px',
          p: '5px 90px',
        }}
        onClick={() => navigate('/reimbursements')}
      >
        {dictionary.exit}
      </Button>
    </Stack>
  );
};
